export enum AccountType {
  PERSON = 'PERSON',
  LEGAL = 'LEGAL',
  IP = 'IP',
}
